import { Button } from 'components/buttons/Button';
import { SearchBox } from 'components/filters/SearchBox';
import { DashboardLayout } from 'components/layout/DashboardLayout';
import { GeneralTable } from 'components/tables/GeneralTable';
import { useCustomSelector } from 'hooks';
import React, { useEffect } from 'react';
import { useTableColumns } from './hooks/useTableColumns';

import "assets/scss/distributorPortal/modules/activityLog.scss";
import { MultiFilters } from 'components/filters/MultiFilters';
import { convertArrayToDropdownArrayFormat, convertToAPIDateFormat, getTotalCountFromHeader, isObjectEmpty } from 'functions';
import useLogging from 'dataflow/distributorPortal/actions/useLogging.actions';
import { DateRangePicker } from 'components/form/DateRangePicker';
import moment from 'moment';

function ActivityLog(props) {

    const { 
        getActivityLog_requesting, activityLog, 
        activityLogHeaders, moduleNameList 
    } = useCustomSelector("distributorPortal_logging");

    const { getActivityLog, getModuleNames } = useLogging();
    useEffect(() => {
        getModuleNames();
    }, [])

    const {
        userPermissions
    } = useCustomSelector("distributorPortal_userManagementReducers");

    const columns = useTableColumns();

    return (
        <DashboardLayout
            headerTitle={"Activity Log"}

            bodyClassName={"activity-log"}
            body={(
                <GeneralTable
                    className={"activity-log__table"}
                    columns={columns}
                    data={userPermissions?.Dealer_General_ViewActivityLog? activityLog: []}

                    getTableData={getActivityLog}

                    outerTableHeader={(outerTableHeader_props) => {
                        const { 
                            filterOptions, setFilterOptions
                        } = outerTableHeader_props;

                        return (
                            <div className={"table__headers"}>
                                {/* Top Section */}
                                <div className={"headers__top-section d-flex justify-content-between align-items-center"}>
                                    {/* Title */}
                                    <div className={"headers__title tableHeaderTitle "}>
                                        List
                                    </div>
                                </div>

                                {/* Bottom Section */}
                                <div className={"headers__bottom-section"}>
                                    <DateRangePicker
                                        label={"Date"} isLabelRequired
                                        className={"bottom-section__date-range"}
                                        handleOnChange_start={(date) => {
                                            setFilterOptions({
                                                ...filterOptions,
                                                fromDate: date
                                            })
                                        }}
                                        handleOnChange_end={(date) => {
                                            setFilterOptions({
                                                ...filterOptions,
                                                toDate: date
                                            })
                                        }}
                                    />
                                    
                                    {/* <MultiFilters
                                        defaultFilterOption={{
                                            label: "Username", 
                                            propertyName: "loggerUser",
                                            placeholder: "Username",
                                            inputType: "search",
                                        }}
                                        filterOptions={[
                                            {
                                                label: "Username", 
                                                propertyName: "loggerUser",
                                                placeholder: "Username",
                                                inputType: "search",
                                            },
                                            // {
                                            //     label: "Module", 
                                            //     propertyName: "module",
                                            //     placeholder: "Module",
                                            //     options: convertArrayToDropdownArrayFormat(moduleNameList),
                                            //     inputType: "dropdown"
                                            // },
                                            // {
                                            //     label: "Reference Key", 
                                            //     propertyName: "referenceKey",
                                            //     placeholder: (filterOptions?.module === "invoice" || filterOptions?.module === "billingsetup"? "Enter Account Code":
                                            //         filterOptions?.module === "user"? "Enter User Email":
                                            //         filterOptions?.module === "compInfo"? "Enter COM ID":
                                            //         filterOptions?.module === "general"? "Not Applicable":""),
                                            //     inputType: "search",
                                            //     isDisabled: filterOptions?.module === "general",
                                            // },
                                            {
                                                label: "Date", 
                                                propertyName_start: "fromDate",
                                                propertyName_end: "toDate",
                                                placeholder_start: "Start",
                                                placeholder_end: "End",
                                                inputType: "dateRange",
                                                isNotUsingMonthYear: true
                                            }
                                        ]}
                                        dropdownPlaceholder={"Select Filter"}
                                        onApplyFilter={(inputFilters) => {
                                            setFilterOptions(isObjectEmpty(inputFilters)? {}: { ...filterOptions, ...inputFilters});
                                        }}
                                    /> */}
                                </div>
                            </div>
                        );
                    }}
                    
                    isTableDataLoading={getActivityLog_requesting}

                    isUsingPagination
                    totalRecords={getTotalCountFromHeader(activityLogHeaders)}

                    isColumnResizeable
                    isTableOddRowsDarken
                />
            )}
        />
    );
}

export default ActivityLog;